import { render } from "./GenReports.vue?vue&type=template&id=23699fc0&scoped=true"
import script from "./GenReports.vue?vue&type=script&lang=js"
export * from "./GenReports.vue?vue&type=script&lang=js"

import "./GenReports.vue?vue&type=style&index=0&id=23699fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23699fc0"]])

export default __exports__